export const COST_PER_ALERT = 7;
